

























































import { Component, Vue } from 'vue-property-decorator';
import { PublicHolidayFilter, PublicHolidayGroupEditModel, PublicHolidayViewModel } from '@/services/api/nswag/stapiclient_generated';
import { stPublicHolidayApi, stPublicHolidayGroupApi } from '@/services/st-api';
import StRatePicker from '@/components/basic/StRatePicker.vue';
import SlideIn from '@/components/basic/SlideIn.vue';
import StInput2 from '@/components/basic/StInput2.vue';
import StToggle from '@/components/basic/StToggle.vue';
import StExplanation from '@/components/basic/StExplanation.vue';
import { UserStore } from '@/store/user-module';
import { dateEqual, DtFromIso } from '@/utlitities/helper';
import { DateTime } from 'luxon';

Component.registerHooks(['beforeRouteUpdate']);

@Component({
  components: {
    StExplanation,
    StToggle,
    StInput2,
    SlideIn,
    StRatePicker
  },
})
export default class PublicHolidayGroupEdit extends Vue {
  id: number = 0;
  group: PublicHolidayGroupEditModel = PublicHolidayGroupEditModel.fromJS({ name: '' });
  loading: boolean = true;
  delayLoading = false;
  saving: boolean = false;
  year: number = UserStore.userNowDateTime.year;

  globalViewModels: PublicHolidayViewModel[] = [];
  globalOverwriteDates: DateTime[] = [];
  userViewModels: PublicHolidayViewModel[] = [];

  async beforeRouteUpdate(to: any, from: any, next: any) {
    next();
    if (from.name == 'PublicHolidayGroupEditSlideOut') {
      this.id = parseInt(this.$route.params.id);
      if (!this.id) {
        this.back();
      }
    }
    if (to.name == 'PublicHolidayGroupEdit') {
      try {
        this.delayLoading = true;
        await this.loadData();
      } finally {
        this.delayLoading = false;
      }
    }
  }

  get fromDate(): Date {
    return DateTime.local(this.year, 1, 1, 0, 0, 0, 0).toJSDate();
  }

  created() {
    this.id = parseInt(this.$route.params.id);
  }

  async mounted() {
    if (!this.id) {
      this.loading = false;
      await this.$router.push({
        name: 'PublicHolidayGroupEditSlideOut',
        params: { id: '0' },
      });
    }

    await this.loadData();

    this.loading = false;
  }

  async loadData() {
    if (this.id) {
      this.group = await stPublicHolidayGroupApi.get(this.id);
    } else {
      this.group = await stPublicHolidayGroupApi.getNew();
    }

    if (this.group?.publicHolidayGroupId) {
      this.selectedGlobalGroupId = this.group.publicHolidayGroupId!;
    } else {
      this.selectedGlobalGroupId = null;
    }

    await this.loadYearHolidays(this.year);
  }

  get isGlobal() {
    return this.group?.isGlobal;
  }

  get selectedGlobalGroupId() {
    return this.group?.publicHolidayGroupId ?? null;
  }

  set selectedGlobalGroupId(id: number | null) {
    this.group.publicHolidayGroupId = id ?? undefined;
  }

  get groupId() {
    if (this.group && this.selectedGlobalGroupId == this.group.publicHolidayGroupId) {
      return this.group.id!;
    }

    return this.selectedGlobalGroupId;
  }

  get attributes() {
    let attr: any[] = [];

    attr.push(
      ...this.userViewModels
        ?.filter((x) => !attr.some((y) => dateEqual(y.dates, DateTime.fromISO(x.publicHolidayDate!))))
        ?.map((x: PublicHolidayViewModel) => {
          return {
            dates: x.publicHolidayDate,
            highlight: { color: this.group.isGlobal ? 'blue' : 'green', fillMode: 'solid' },
            popover: { visibility: 'hover' },
            customData: { publicHolidayId: x.id, description: x.description },
          };
        })
    );

    attr.push(
      ...this.globalViewModels
        ?.filter((x) => !attr.some((y) => dateEqual(y.dates, DateTime.fromISO(x.publicHolidayDate!))))
        ?.map((x: PublicHolidayViewModel) => {
          return {
            dates: x.publicHolidayDate,
            highlight: { color: 'blue', fillMode: 'solid' },
            popover: { visibility: 'hover' },
            customData: { publicHolidayId: x.id, description: x.description },
          };
        })
    );

    return attr;
  }

  getUserViewModelForDay(day: DateTime) {
    return this.userViewModels.find((y) => dateEqual(DateTime.fromISO(y.publicHolidayDate!), day));
  }

  async startGroupdEdit(id: number) {
    await this.$router.push({
      name: 'PublicHolidayGroupEditSlideOut',
      params: { id: id.toString() },
    });
  }

  async updateCalendar(calendarEvent: any) {
    if (!calendarEvent.weekday) {
      this.year = calendarEvent.year;
      await this.loadData();
    }
  }

  async dayClicked(e: any) {
    if (this.isGlobal)
      return;

    const userViewModel = this.getUserViewModelForDay(DtFromIso(e.id));

    if (userViewModel) {
      await this.$router.push({
        name: 'PublicHolidayEdit',
        params: { groupId: this.group.id!.toString(), id: userViewModel.id!.toString() },
      });
    } else {
      await this.$router.push({
        name: 'PublicHolidayAdd',
        params: { groupId: this.group.id!.toString(), id: '0', date: e.id },
      });
    }
  }

  async loadYearHolidays(year: number) {
    this.year = year;
    try {
      this.delayLoading = true;

      this.globalOverwriteDates = (
        await stPublicHolidayApi.getOverwrittenAsWorkdayDates(
          PublicHolidayFilter.fromJS({
            publicHolidayGroupId: this.group.id!,
            year: year,
          })
        )
      ).map((x) => DateTime.fromISO(x));

      if (this.selectedGlobalGroupId) {
        this.globalViewModels = (
          await stPublicHolidayApi.getList(
            PublicHolidayFilter.fromJS({
              publicHolidayGroupId: this.selectedGlobalGroupId,
              year: year,
            })
          )
        ).filter((x) => !this.globalOverwriteDates.some((y) => dateEqual(y, DateTime.fromISO(x.publicHolidayDate!))));
      }

      if (this.group?.id) {
        this.userViewModels = await stPublicHolidayApi.getList(
          PublicHolidayFilter.fromJS({
            publicHolidayGroupId: this.group.id!,
            year: year,
            onlyUserHolidays: true,
          })
        );
      }
    } finally {
      this.delayLoading = false;
    }
  }

  back() {
    this.$router.push({ name: 'PublicHolidayGroup' });
  }
}
